<h3>Aprovação de Ilhas Especiais</h3>
<form [formGroup]="formGroup">
  <mat-tab-group mat-align-tabs="left" [mat-stretch-tabs]="false" animationDuration="0ms" (selectedTabChange)="setHistoryTabStatus($event.index === 1)">
    <mat-tab label="Pesquisar">
      <div fxLayout="row" fxLayoutAlign="left stretch">
        <app-operations-proposals-list-filters [exportValid]="exportValid" (onSearch)="searchProposals()" (onExport)="exportProposals()" [parentForm]="formGroup" [fields]="fields"></app-operations-proposals-list-filters>
      </div>
    </mat-tab>

    <mat-tab label="Histórico">
      <app-operations-proposals-list-filters [historyTabActive]="historyTabActive" (onExport)="exportProposalHistory()" [exportValid]="exportHistoryValid" (onSearch)="searchProposalHistory()" [parentForm]="formGroup" [fields]="fields"></app-operations-proposals-list-filters>
    </mat-tab>
  </mat-tab-group>
</form>

<div class='list-proposal'>
  <ng-container *ngIf="!historyTabActive">
    <app-list-operations-proposals (detailEmmiter)="detail($event)" [dataSource]="dataSource" [sizeItems]="sizeItems" [totalPages]="totalPages"
            (actionsEmitter)="actions($event)" (changePage)="changePage($event)">
        </app-list-operations-proposals>
  </ng-container>

  <ng-container *ngIf="historyTabActive">
     <app-list-operations-proposals-history (detailEmmiter)="detail($event)" [dataSource]="historyDataSource"
      [sizeItems]="sizeItems" [totalPages]="totalPages" (changePage)="changeHistoryPage($event)">
    </app-list-operations-proposals-history>

  </ng-container>
</div>
